import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { iDataComponentes } from "../../interfaces/SuperAdmin/Others/iDataComponentes";
import { useAuthContext } from "../../hooks/Auth";
import { LiteralCategoria } from "../../types/LiteralCategoria";
import AppsCard from "../UmmIApps/AppsCard";
import FreshDeskBtn from "../../utils/FreshDeskBtn";

const AppsContainer = ({ filter }: { filter: LiteralCategoria }) => {
  const { user } = useAuthContext();

  // Las apps de esta página
  const [apps, setApps] = useState<iDataComponentes[]>([]);

  // Solo agregamos las apps de esta página en base al filtro
  useEffect(() => {
    if (user) {
      setApps(user.ummiapps.filter((app) => app.categoria === filter));
    }
  }, [user]);

  return (
    <Grid container spacing={{ xs: 4, xl: 10 }} sx={{ px: { xs: 2, md: 4 } }}>
      {apps.map((app) => {
        return (
          <Grid key={app.nombre} item xs={12} sm={6} md={4} lg={3}>
            <AppsCard app={app} />
          </Grid>
        );
      })}
      <FreshDeskBtn />
    </Grid>
  );
};

export default AppsContainer;
